import { FormSubmitButton } from '~/shared/forms/buttons/FormSubmitButton';
import { Check } from 'lucide-react';
import { NavigatePreviousButton } from '../shared/NavigatePreviousButton';
import { NavigateNextButton } from '../shared/NavigateNextButton';
import { type WorkflowStageTaskViewModel } from '@generated';
import { VisitEvaluationToolbar } from '../evaluations/VisitEvaluationToolbar';

export function VisitWorkflowStageTaskFooter({
	workflowStageTask,
	isResolvedView,
	disableSubmitOnResolved
}: {
	workflowStageTask: WorkflowStageTaskViewModel;
	isResolvedView: boolean;
	disableSubmitOnResolved?: boolean;
}) {
	return (
		<>
			<div className="flex space-x-2">
				<NavigatePreviousButton />
				<NavigateNextButton label="Skip" />
			</div>
			<VisitEvaluationToolbar />
			<div className="flex space-x-2">
				{isResolvedView || (disableSubmitOnResolved && workflowStageTask.resolved) ? (
					<NavigateNextButton />
				) : (
					<FormSubmitButton submitLabel="Save" submittingLabel="Saving" Icon={Check} />
				)}
			</div>
		</>
	);
}
